export default __webpack_public_path__ + "static/media/qr-scanning.b574d2d1.png";